import * as React from 'react';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
import { classes } from '../../helpers';
export const Text = (props) => {
    const theme = useTheme();
    const css = classes(style({ props, theme }), props.className);
    const element = {
        h1: React.createElement("h1", null),
        h2: React.createElement("h2", null),
        h3: React.createElement("h3", null),
        h4: React.createElement("h4", null),
        h5: React.createElement("h5", null),
        h6: React.createElement("h6", null),
        p: React.createElement("p", null),
        label: React.createElement("label", null),
    }[props.variant] || React.createElement("span", null);
    return React.cloneElement(element, {
        className: css,
        style: props.style,
        onClick: props.onClick,
        children: props.children,
    });
};
Text.defaultProps = {
    italicize: false,
    fontWeight: 'normal',
    padding: '',
    margin: '',
    style: {},
    onClick: () => ({}),
};
//# sourceMappingURL=Text.js.map